<template>
  <!--  </TabPanel>-->
  <Panel header="Danh sách nghỉ phép">
    <div class="p-fluid">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-4">
          <label>Chọn khoản thời gian thống kê nghỉ phép: </label>
          <Calendar
              id="date"
              v-model="date"
              selectionMode="range"
              dateFormat="dd/mm/yy"
              :showButtonBar="true"
              :showIcon="true"
              :manualInput="false"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2100"
              @date-select="selectCalendar()"
              @clear-click="clearCalendar()"
          />
        </div>
        <div class="p-field p-col-12 p-md-12">
      <DataTable
              :value="listDayOff" :paginator="true" stripedRows
              :rows="10" :rowsPerPageOptions="[10,25,50]" :rowHover="true"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :globalFilterFields="['hoVaTen','soDienThoai','thoiGian']"
              currentPageReportTemplate="Có tất cả {totalRecords} lượt nghỉ phép"
              v-model:filters="filters" style="font-size: 13px">
        <Column field="hoVaTen" header="Họ và tên" sortable></Column>
        <Column field="soDienThoai" header="Số điện thoại" sortable></Column>
        <Column field="thoiGian" dataType="date" header="Thời gian bắt đầu nghỉ" sortable>
          <template #body="{data}">
            {{data.ngayTrongTuan}},{{formatDateTime(data.thoiGian)}}
          </template>
        </Column>
        <Column field="soNgay" header="Số ngày" sortable></Column>
        <Column field="lyDo" header="Lý do" sortable></Column>
        <Column field="xacNhan" header="Tình trạng" sortable>
          <template #body="{data}">
            {{status(data.idXacNhan, data.xacNhan)}}
          </template>
        </Column>
        <Column field="nguoiXacNhan" header="Người xác nhận" sortable></Column>
        <template #empty>
          Không có thông tin danh sách nghỉ phép.
        </template>
      </DataTable>
        </div>
      </div>
    </div>
<!--    </div>-->
  </Panel>
</template>

<script lang="ts">

  import { computed, ref } from 'vue'
  import moment from 'moment';
  import {FilterMatchMode, FilterOperator} from "primevue/api";
  import router from "@/router";
  import {useToast} from "primevue/usetoast";
  import {useStore} from "vuex";
  import {RegisterService} from "@/models/registerService";
  import ZaloRepository from "@/services/ZaloRepository";
  import {ListService} from "@/models/listService";
  import {useRouter} from "vue-router";
  import {NghiPhepDetail} from "@/models/nghiPhepDetail";
  import zaloRepository from "@/services/ZaloRepository";

  export default {
    setup() {
      const toast = useToast();
      const store = useStore();
      const date = ref();
      const service = ref("");
      const router = useRouter();
      const kind = ref(0);
      const listDayOff = ref([] as NghiPhepDetail[]);

      const selectCalendar = () => {
        if((date.value[0] != null)&&(date.value[1] != null))
        {
          listDayOff.value = [];
          zaloRepository.getListDayOff(date.value[0]/1000, date.value[1]/1000)
              .then((response) => {
                listDayOff.value = response.data;
                console.log("@@@@@@@@@################ list: " + JSON.stringify(listDayOff.value));
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })})
        }
      };

      //selectCalendar();

      const clearCalendar = () => {
        listDayOff.value = [];
      }

      const formatDateTime = (date) => {
        if((date == null)||(date == ''))
        {
          return "chưa có thông tin"
        }
        else
        return moment(String(date)).format(' DD/MM/YYYY');
      };


      const validDate = (registerService: RegisterService) => {
        return registerService.timeConfirm;
      }

      const clearDate = () => {
        console.log("@@@@@@@@@################ clearDate");
        date.value = new Date();
      }

      const status = (id, xn) => {
        if(xn) return "Cho phép nghỉ";
        else {
          if(id > 0) return "Không cho phép nghỉ";
          else return "Chưa xác nhận";
        }
      }

      return {
        formatDateTime,
        listDayOff,
        date,
        selectCalendar,
        clearCalendar,
        service,
        validDate,
        kind,
        clearDate,
        status
      }
    }

  }
</script>
<style lang="scss">
</style>